import $ from 'jquery';
import { loadModal } from '../../../AsyncLoader';
import PackageDetailTicketSelector from './PackageDetailTicketSelector';

const defaults = {
  modalBtnCloseLabel: 'Close',
};

const initMoreInfoButtons = async (config) => {
  const $btns = $('.tn-package-perf__btn-more-info');
  if ($btns.length === 0) {
    return;
  }

  const Modal = await loadModal();

  $btns.show();
  $btns.on('click', (event) => {
    const { pkgPerfId, pkgPerfTitle } = event.currentTarget.dataset;
    const { modalBtnCloseLabel } = config;
    const templateEl = document.querySelector(`#tn-pkg-perf-desc-template-${pkgPerfId}`);
    const html = templateEl.innerHTML;

    Modal.alert({
      title: pkgPerfTitle,
      bodyContents: html,
      labelBtnAccept: modalBtnCloseLabel,
      returnFocusTo: event.currentTarget,
    });
  });
};

function initialize(formSelector, packageDetailConfig, ticketSelectorOptions) {
  const config = { ...defaults, ...packageDetailConfig };

  const $form = document.querySelector(formSelector);

  if ($form) {
    new PackageDetailTicketSelector($form, ticketSelectorOptions);
  }

  initMoreInfoButtons(config);
}

window.tnew.page.initialize = initialize;